<template>
  <section id="section__kyc" class="view-container">
    <div class="width-100">
      <p class="font--p-3 mt-5 mb-10">
        사업장의 <br />
        정보를 확인할게요
      </p>
      <v-row no-gutters>
        <v-col cols="12">
          <label class="font-size--16">상점명</label>
          <v-text-field
            class="mb-3"
            v-model="user.store.name"
            :error="!!invalidMsg.name"
            :rules="rules.name"
            hide-details
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.name" />
          <label class="font-size--16">사업자등록번호(10자리)</label>
          <v-text-field
            v-model="user.store.businessLicenseNumber"
            :error="!!invalidMsg.businessLicenseNumber"
            :rules="rules.businessLicenseNumber"
            hide-details
            maxlength="10"
            class="mb-3"
            type="tel"
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.businessLicenseNumber" />
          <label class="font-size--16">사업장 주소</label>
          <DaumAddr :isOpen.sync="daumAddrOpen" @update:addr="oncompleteAddr" class="mt-2" />
          <v-text-field
            v-model="user.store.address1"
            class="mb-3"
            hide-details
            :error="!!invalidMsg.address1"
            :rules="rules.address1"
            placeholder="주소"
            @click="daumAddrOpen = !daumAddrOpen"
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.address1" />
          <v-text-field
            v-model="user.store.address2"
            class="mb-3"
            ref="address2"
            placeholder="상세주소"
            hide-details
          ></v-text-field>
          <label class="font-size--16">업종</label>
          <v-select
            class="mb-3"
            v-model="user.store.typeOfBusiness"
            :rules="rules.typeOfBusiness"
            :items="businessTypes"
            required
          ></v-select>
          <!-- <label class="font-size--16">대출금 사용처</label>
          <v-select
            class="mb-3"
            v-model="user.purposesOfLoan"
            :items="loanPurposes"
            :rules="rules.purposesOfLoan"
            required
          ></v-select> -->
          <!-- 주민등록번호 입력 필드 주석 처리 -->
          <!--
          <label class="font-size--16">주민등록번호</label>
          <v-text-field
            v-model="user.residentRegistrationNumber"
            class="mb-3"
            :error="!!invalidMsg.residentRegistrationNumber"
            :rules="rules.residentRegistrationNumber"
            hide-details
            required
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.residentRegistrationNumber" />
          -->
        </v-col>
      </v-row>
      <BasicButton @click="next()" :loading="nextLoading" :disabled="nextLoading || !isValidAll">{{
        btnText ? btnText : '다음'
      }}</BasicButton>
    </div>
  </section>
</template>

<script>
import DaumAddr from '@/components/address/DaumAddr.vue'
import Regex from '@/const/Regex'

import { mapActions, mapState } from 'vuex'
import { simpleClone } from '@/util'

export default {
  props: {
    btnText: {
      type: String,
      required: false,
    },
  },
  components: {
    DaumAddr,
  },
  data() {
    return {
      user: {
        purposesOfLoan: '가게 운영 자금',
        store: {
          name: null,
          businessLicenseNumber: null,
          address1: null,
          address2: null,
          typeOfBusiness: null,
          zipCode: null,
        },
        //residentRegistrationNumber: null,
      },
      businessTypes: ['요식업', '도/소매업', '서비스업', '기타'],
      loanPurposes: ['가게 운영 자금', '생활비', '타 금융 대환', '기타'],
      daumAddrOpen: false,
      nextLoading: false,
      rules: {
        name: [(value) => !!value || '상점명을 입력해주세요'],
        businessLicenseNumber: [
          (value) => !!value || '사업자등록번호를 입력해주세요',
          (value) => Regex.LICENSENUMBER.REGEX.test(value) || Regex.LICENSENUMBER.MSG,
        ],
        address1: [(value) => !!value || '주소를 입력해주세요'],
        typeOfBusiness: [(value) => !!value || '업종을 선택해주세요'],
        // residentRegistrationNumber: [(value) => !!value || '주민등록번호를 입력해주세요.'],  // 주석 처리
      },
      invalidMsg: {},
      address1IsValid: false,
      typeOfBusinessIsValid: false,
      businessLicenseNumberIsValid: false,
      // residentRegistrationNumberIsValid: false,  // 주석 처리
      nameIsValid: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    kycCdd() {
      return {
        address: `${this.user.store.address1} ${this.user.store.address2} (${this.user.store.zipCode})`,
      }
    },
    kycEdd() {
      return {
        typeOfBusiness: this.user.store.typeOfBusiness,
        purposesOfLoan: this.user.purposesOfLoan,
      }
    },
    isValidAll() {
      return (
        this.address1IsValid === true &&
        this.typeOfBusinessIsValid === true &&
        this.businessLicenseNumberIsValid === true &&
        // this.residentRegistrationNumberIsValid === true &&  // 주석 처리
        this.nameIsValid === true
      )
    },
  },
  watch: {
    'user.store.name'(v) {
      // 상호명 중복 검사
      this.nameDuplicate(v)
    },
    'user.store.address1'(v) {
      const msg = this.getFormErrMsg('address1', v)
      this.address1IsValid = msg === null
    },
    'user.store.typeOfBusiness'(v) {
      const msg = this.getFormErrMsg('typeOfBusiness', v)
      this.typeOfBusinessIsValid = msg === null
    },
    'user.store.businessLicenseNumber'(v) {
      this.licenseNumberDuplicate(v)
    },
    // 'user.residentRegistrationNumber' watcher 주석 처리
    /*
    'user.residentRegistrationNumber'(v) {
      const msg = this.getFormErrMsg('residentRegistrationNumber', v)
      this.residentRegistrationNumberIsValid = msg === null
    },
    */
  },
  async created() {
    this.user = Object.assign(this.user, simpleClone(this.me))
    const companyName = this.getCookieAndRemove('companyName')
    if (companyName) {
      this.user.store.name = companyName
    }
    const businessLicenseNumber = this.getCookieAndRemove('businessLicenseNumber')
    if (businessLicenseNumber) {
      this.user.store.businessLicenseNumber = businessLicenseNumber
    }
  },
  methods: {
    ...mapActions('auth', ['getMe', 'updateMe']),
    ...mapActions('kyc', ['addEdd', 'addCdd', 'getMobileAuthUrl']),
    ...mapActions('store', ['updateStore']),
    ...mapActions('signup', ['getUserCheckDuplication', 'addUsersSignUpErrorRecords']),
    getCookieAndRemove(name) {
      const v = this.$cookies.get(name)
      this.$cookies.remove(name)
      return v
    },
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    async licenseNumberDuplicate(businessLicenseNumber) {
      const msg = this.getFormErrMsg('businessLicenseNumber', businessLicenseNumber)
      if (msg == null) {
        this.businessLicenseNumberIsValid = true
      } else {
        this.businessLicenseNumberIsValid = false
      }
    },
    nameDuplicate(name) {
      const msg = this.getFormErrMsg('name', name)
      if (msg === null) {
        this.nameIsValid = true
      } else {
        this.nameIsValid = false
      }
    },
    oncompleteAddr(addrObj) {
      this.user.store.address1 = addrObj.address
      this.user.store.zipCode = addrObj.zonecode
      this.$nextTick((_) => {
        this.$refs.address2.focus()
      })
    },
    async next() {
      try {
        this.nextLoading = true
        const { businessLicenseNumber } = this.user.store
        if (businessLicenseNumber !== this.me.store.businessLicenseNumber) {
          const result = await this.getUserCheckDuplication({
            businessLicenseNumber,
          })

          if (result) {
            const { isConfirmed } = await this.$swal.basic.confirm({
              title: '사업자 번호 중복',
              html: `입력하신정보가 이미 존재합니다.<br/><br/>
              본인확인을 위해 운영팀에서<br/> 
              유선으로 연락 드릴 예정입니다.<br/>
              02-6925-1788<br/><br/>`,
            })
            if (isConfirmed) {
              await this.addUsersSignUpErrorRecords({
                errors: [
                  {
                    fieldName: 'business_license_number',
                    value: businessLicenseNumber,
                    type: 'duplication',
                  },
                ],
              })
              await this.$router.push('/signup/problem')
            }
            return
          }
        }

        await this.addEdd(this.kycEdd)
        await this.addCdd(this.kycCdd)
        await this.updateStore(this.user.store)
        await this.updateMe({
          ...this.user,
          // residentRegistrationNumber: this.user.residentRegistrationNumber.replace(/[^0-9]/g, ''),  // 주석 처리
        })
        await this.getMe()
        this.$emit('emitResult', true)
      } catch (e) {
        await this.getMe()
        throw e
      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
